<template>
  <v-container grid-list-xl text-xs-center class="login-page">
    <v-layout row justify-center>
      <v-flex xs4 mt-10 justify-center class="d-flex">
        <div>
          <router-link to="/">
            <v-img :src="require('@/assets/logo.svg')" class="logo" alt="logo"></v-img>
          </router-link>
        </div>
      </v-flex>
    </v-layout>
    <v-layout row justify-center>
      <v-flex xs4>
        <div class="enter_system">Вход в систему</div>
      </v-flex>
    </v-layout>
    <!-- <v-layout row justify-center v-if="validationErrors !== null">
      <v-flex xs4 mt-2 justify-center>
        <v-alert color="red" text type="error">{{ validationErrors }}</v-alert>
      </v-flex>
    </v-layout> -->
    <v-layout row justify-center>
      <v-flex lg3>
        <v-form @submit.prevent="onSubmit" class="form-login">

          <v-text-field
              v-model="login"
              autocomplete="off"
              outlined
              class="input"
              placeholder="Имя пользователя"
              :error-messages="errors.login"
              :error="!!errors.login"
          >
          </v-text-field>

          <v-text-field
              v-model="password"
              :append-icon="value ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
              @click:append="() => (value = !value)"
              :type="value ? 'password' : 'text'"
              outlined
              placeholder="Пароль"
              color="secondary"
              class="input password-input"
              :error-messages="errors.password"
              :error="!!errors.password"
          >
          </v-text-field>

          <v-select
              v-if="units && units.units"
              v-model="unit"
              :items="units.units"
              item-text="number"
              return-object
              :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
              placeholder="Выберите трубку"
              append-icon="mdi-chevron-down"
              outlined
          ></v-select>

          <v-btn type="submit" class="button mt-6" style="height: 48px !important;">
            Войти
          </v-btn>
        </v-form>
      </v-flex>
    </v-layout>
    <v-layout row justify-center>
      <v-flex xs4>
        <div class="remember_me" @click="showModal('forgot')">
          <span>Забыли пароль?</span>
        </div>
      </v-flex>
    </v-layout>
    <v-layout row justify-center>
      <v-flex xs4 mt-15>
        <div class="version">
          2025. Версия 1.0
        </div>
      </v-flex>
    </v-layout>
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="393px">
        <v-card rounded="lg">
          <v-card-title class="text-center">
            <v-spacer></v-spacer>
            <v-btn icon @click="dialog = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text style="padding-bottom: 70px;">
            <v-container>
              <div class="text-center">
                <h3 class="text-center forgot-title">Забыли пароль?</h3>
              </div>
              <v-row align="center" class="mt-5 d-flex flex-column justify-center">
                <div class="text-center forgot-text">
                  Для востановления пароля обратитесь к администратору или непосредственному руководителю
                </div>
              </v-row>
            </v-container>
          </v-card-text>

        </v-card>
      </v-dialog>
    </v-row>
    <Modal ref="forgot" :notFooterBorder="true" padding="57-94" :hideHeader="true" size="small">
      <template v-slot:body>
        <div class="forgot">
          <div class="heading">
            Забыли пароль?
          </div>
          <div class="message">
            Для востановления пароля обратитесь
            к администратору или непосредственному руководителю
          </div>
        </div>
      </template>
    </Modal>
  </v-container>
</template>
<script>
import { mapState } from 'vuex'
import router from '@/router/index'
import { actionTypes } from '@/store/modules/auth'
import {uisActionTypes} from '@/store/modules/uis';
import {getItem, setItem} from '@/helpers/persistanceStorage'

export default {
  name: 'McvLogin',
  data() {
    return {
      login: '',
      errors: {
        login: null,
        password: null,
      },
      password: '',
      remember: false,
      value: String,
      dialog: false,
      currentPort: 8071,
      maxPort: 8079,
      cashbox: [],
      unit: null
    }
  },
  computed: {
    ...mapState({
      isSubmitting: state => state.auth.isSubmitting,
      units: state => state.uis.units,
      validationErrors: state => state.auth.validationErrors
    })
  },
  mounted() {
    this.fetchFeed()
  },
  methods: {
    fetchFeed() {
      this.$store.dispatch(uisActionTypes.getUnits);
    },
    showModal(modalName) {
      this.$refs[modalName].show({}).then((result) => { })
    },
    sendRequest() {
      var xmlhttp = new XMLHttpRequest();
      let vm = this;
      xmlhttp.onreadystatechange = function() {
        // Реализация когда скрипт останавливается как только находит ответ
        // if (xmlhttp.readyState === XMLHttpRequest.DONE) {
        //   if (xmlhttp.status === 200) {
        //     vm.cashbox.push(JSON.parse(xmlhttp.responseText));
        //     setItem('list-cashbox', vm.cashbox);
        //   } else {
        //     vm.currentPort < vm.maxPort ? vm.currentPort = vm.currentPort + 1 : vm.currentPort = 8071
        //     vm.sendRequest();
        //   }
        // }
        // Реализация когда скрипт пробегается по всем портам и собирает успешный ответ
        if (xmlhttp.readyState === XMLHttpRequest.DONE) {
          if (vm.currentPort < vm.maxPort) {
            if (xmlhttp.status === 200) {
              vm.cashbox.push(JSON.parse(xmlhttp.responseText));
              setItem('list-cashbox', JSON.stringify(vm.cashbox));
            }
            vm.currentPort = vm.currentPort + 1;
            vm.sendRequest();
          }
        }
      }

      xmlhttp.open("GET", `http://localhost:${vm.currentPort}/about`);
      xmlhttp.send();
    },
    onSubmit() {
      if(this.login === 'admin') {
        if(this.password === 'admin') {
          setItem('accessToken', 'someadmintoken')
          setItem('type', 'Администратор')
          setItem('fio', 'Галеева В Н')
          this.sendRequest();
          router.push({ path: '/admin-main' });
        } else {
          this.$set(this, 'errors', {
            //login: 'Неверное имя пользователя',
            password: 'Неверный пароль',
          })
        }
      } else {
        this.$store.dispatch(actionTypes.login, {
            login: this.login,
            password: this.password,
            unit: this.unit,
          })
          .then(() => {
            this.sendRequest();
            router.push({ path: '/main' });
          })
      }
    }
  },
  watch: {
    validationErrors: function (value) {
      if (value) {
        this.$set(this, 'errors', {
          login: 'Неверное имя пользователя',
          password: 'Неверный пароль',
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.login-page {
  .button {
    width: 100% !important;
    background-color: #629F33 !important;
    border-radius: 12px !important;
    color: #FFFFFF !important;
  }

  .logo {
    width: 334px;
  }

  .input {
    border-radius: 12px !important;

  }

  // .v-input__slot {
  //   border: 1px solid #E0E0E0 !important;
  // }

  .enter_system {
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    margin-top: 131px;
    text-align: center;
  }

  .remember_me {
    text-align: center;
  }

  .remember_me span {
    color: #629F33;
    text-decoration: underline;
    cursor: pointer;
  }

  .version {
    color: #000;
    opacity: 0.5;
    text-align: center;
  }

  .forgot-title {
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    color: #000000;
  }

  .forgot-text {
    width: 279px;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    color: #1A1A1A;
  }

  .v-input--checkbox {
    .v-label {
      color: #1A1A1A;
      font-family: 'Circe';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
    }
  }

  .form-login {
    .v-text-field__details {
      padding-left: 0 !important;
    }

    .v-input__slot {
      border: none !important;
    }

    .password-input {
      &.error--text {
        fieldset {
          &::after {
            right: 45px !important;
          }
        }

        .v-icon {
          color: #767676 !important;
        }
      }
    }


    .v-text-field--outlined {
      &.error--text {
        fieldset {
          border: 1px solid #D53025 !important;

          &::after {
            content: "";
            width: 20px;
            height: 20px;
            display: block;
            position: absolute;

            background-image: url('../assets/warning-icon.svg');
            background-size: cover;
            right: 18px;
            top: -3px;
            bottom: 0;
            margin: auto;
            z-index: 2;
          }
        }
      }

      fieldset {
        border: 1px solid #E0E0E0 !important;
      }
    }

    button {
      &[type="submit"] {
        box-shadow: none !important;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        margin-top: 0!important;
      }
    }
  }

  .forgot {
    .heading {
      font-family: 'Circe';
      font-style: normal;
      font-weight: 700;
      font-size: 20px;
      line-height: 24px;
      text-align: center;

      color: #000000;
    }

    .message {
      padding-top: 15px;
      font-family: 'Circe';
      font-style: normal;
      font-weight: 400;
      font-size: 13px;
      line-height: 16px;
      text-align: center;
      color: #1A1A1A;
    }
  }
}
</style>

